import { useEffect, useRef, useState } from "react";

export const useDebounce = (value, delay = 400) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const timerRef = useRef(null);

  useEffect(() => {
    if (value === "") {
      setDebouncedValue("");
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      return;
    }
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    timerRef.current = timer;

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};
